import React from 'react';
import { Modal } from 'react-responsive-modal';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { RootState } from '@/models';
import styles from './index.module.scss';

const closeIcon = (
  <span style={{ fontSize: '26px' }}>
    <svg className="icon" aria-hidden="true">
      <use xlinkHref="#icon-clear-copy" />
    </svg>
  </span>
);
const GlobalModal = () => {
  const { isOpen, content, title } = useSelector((state: RootState) => state.modal);
  const dispatch = useDispatch();
  const close = () => {
    dispatch({ type: 'modal/close' });
  };
  return (
    <Modal
      open={isOpen}
      onClose={close}
      center
      closeIcon={closeIcon}
      classNames={{
        overlay: styles.customOverlay,
        modal: styles.customModal,
        closeButton: styles.customCloseButton,
      }}
    >
      <div className={styles.mainContent}>
        {title && <div className={classNames('flex-row-nowrap', styles.title)}>{title}</div>}
        {content}
      </div>
    </Modal>
  );
};

export default GlobalModal;
